import { Injectable, Signal } from '@angular/core';
import { IIntroductionData, IIntroductionModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IIntroductionState, IntroductionActions, IntroductionSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class IntroductionStore extends StateAccessService<IIntroductionState> {
  readonly state$: Observable<IIntroductionState>;

  readonly data$$: Signal<IIntroductionData>;
  readonly model$$: Signal<IIntroductionModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(IntroductionSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(IntroductionSelectors.data);
  }

  dispatchIntroductionReset() {
    this.stateFacade.dispatch(IntroductionActions.reset());
  }
  dispatchIntroductionLoad() {
    this.stateFacade.dispatch(IntroductionActions.load());
  }
  dispatchIntroductionLoadSuccess({ model, data }: { model: IIntroductionModel; data: IIntroductionData }) {
    this.stateFacade.dispatch(IntroductionActions.loadSuccess({ model, data }));
  }
  dispatchIntroductionSubmit() {
    this.stateFacade.dispatch(IntroductionActions.submit());
  }
  dispatchIntroductionSubmitSuccess({ model, data }: { model: IIntroductionModel; data: IIntroductionData }) {
    this.stateFacade.dispatch(IntroductionActions.submitSuccess({ model, data }));
  }
}
